module.exports = __webpack_public_path__ + "static/media/header-faq.819261a7.svg";